import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Toaster from 'v-toaster'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'v-toaster/dist/v-toaster.css'
import VueMask from 'v-mask'

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Toaster, {timeout: 5000});
Vue.use(VueMask);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
